import { COLORS_CHART } from "constants/DashboardContanst";
import React from "react";
import ReactApexChart from "react-apexcharts";

const DonutChart = ({ data }) => {
  // Prepare data for the chart
  const chartData = data.map(item => ({
    x: item.transport_name,
    y: item.total_record,
  }));

  // Set chart options
  const options = {
    chart: {
      type: "donut",
    },
    // labels: chartData.map(item => item.x),
    labels: chartData.map(item => `${item.x} (${item.y} yêu cầu)`),
    series: chartData.map(item => item.y),
    colors: COLORS_CHART,
    legend: {
      horizontalAlign: "left",
      position: "left",
    },
  };

  return (
    <div style={{ maxWidth: "60%" }}>
      <ReactApexChart
        options={options}
        series={options.series}
        type="donut"
        height="300"
      />
    </div>
  );
};

export default DonutChart;
